import React from "react";

const AbsentFilter = ({ schoolsListing, handleCallback,selectedSchool }) => {
    return (
        <>
            {
                schoolsListing.schools != null && schoolsListing.schools != undefined ?
                    <div>
                        <div className="d-flex align-items-center justify-content-center me-2">

                            <div className="selectBy">
                                <select
                                    className="form-select"
                                    value={selectedSchool || ""}
                                    onChange={(event) => handleCallback(event.target.value)}
                                    aria-label="Select schools by name"
                                >
                                    <option value="">Alle Scholen</option>
                                    {schoolsListing.schools.map((school, i) => (
                                        <option value={school.id} key={i}>
                                            {school.name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>
                    </div> : {}
            }
        </>

    )
}

export default AbsentFilter;